import { useMemo } from 'react';

import _ from 'lodash';
import { baseTypes } from 'modules';

import { IListPageControl } from '../layer0';



export interface IStandardPaginationParams {
  type: 'standard';
  currentPageCursor: string;
  pageSize: number;
  totalRows: number;
  pageCursors: string[];

  onPageChanged: (cursor: string) => void;
}



export function useStandardPaginationParams<TNodeData>({
  page, control
}: {
  page: baseTypes.IPage<TNodeData>;
  control: IListPageControl;
}): IStandardPaginationParams {
  const {
    paginationInput: {
      after,
      first
    },
    setCursor
  } = control;
  const { pages, totalRows } = page;

  const memoizedArgs = useMemo(
    (): IStandardPaginationParams => ({
      type: 'standard',
      currentPageCursor: after || '',
      pageSize: first,
      pageCursors: pages,
      totalRows,
      onPageChanged: _.noop
    }),
    [after, first, pages, totalRows]
  );

  memoizedArgs.onPageChanged = setCursor;

  return memoizedArgs;
}

